import FlashLib from "flashlib";
import EntryPoint from "Engine/EntryPoint";
import MoneyFormat from "Base/MoneyFormat";

export default class BaseSymbolPaysContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.init();
    }

    init() {
        this.id = +this.name.replace('symbolPays_', '');
        this.coefs = EntryPoint.configData.paytable[this.id - 1];

        this.countValueText = this.getChildByName('countValueText');
        //this.valueText = this.getChildByName('valueText');
    }

    setValue(value) {
        //let sss = this.coefs.concat().reverse();
        let strValue = '';
        let strCount = '';
        let item = null;
        for (let i = this.coefs.length - 1; i >= 0; i--) {
            item = this.coefs[i];
            let text = this.getChildByName(`valueText${i+1}`);
            if (item && item > 0 && text) {
                text.text = MoneyFormat.format(item * value, false);
                strCount += (i + 1).toString() + '\n';

                text.scale.set(1);
                if (text.origWidth > text.width) {
                    text.origWidth = text.width;
                    text.scale.set(text.scale.x);
                }
                text.correctPosition(null, 'center');
            }
        }

        /*sss.forEach((item, index)=>{
            if(item && item > 0) {
                strValue += MoneyFormat.format(item * value, false) + '\n';
                strCount += (index + 1).toString() + '\n';
            }
        });*/
        //this.valueText.text = strValue;
        this.countValueText.text = strCount;
    }
}